var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 50,
    viewBox: "0 0 86 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#61j4wczjoa)",
    stroke: "#83BF1F",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.602 6.86 14.145.704.698 19.178l8.456 6.156L22.602 6.86zM76.088 25.33l8.457-6.156L71.098.7 62.64 6.855 76.088 25.33zM12 22l6 5M42.75 39.19l3.06 2.63a3.53 3.53 0 0 1-4.64 5.32L39 45.5M51.82 19.45l12.3 10.57a3.53 3.53 0 0 1-4.64 5.32l-7.11-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.38 28.74 5.4 5a3.53 3.53 0 0 1-4.64 5.32l-5.77-5.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.38 33.87 4.06 3.54a3.53 3.53 0 0 1-4.64 5.32l-4.06-3.54M63.5 8l-7.853 1.905L41.862 8 21 10.507c3.613 3.523 7.035 5.448 12.227 4.826l2.596-.316c.487 3.514 4.238 5.37 8.02 4.915L52.5 19.5M64.12 30.02l10.97-6.71M24.106 31.434a3.53 3.53 0 0 0-5.544-4.372l-2.21 2.803a3.53 3.53 0 0 0 5.543 4.372l2.21-2.803z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.644 35.804a3.53 3.53 0 1 0-5.544-4.372l-2.21 2.803a3.53 3.53 0 0 0 5.543 4.372l2.21-2.803zM35.196 40.182a3.53 3.53 0 1 0-5.544-4.372l-2.21 2.803a3.53 3.53 0 1 0 5.543 4.372l2.21-2.803z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.53 47.348a3.53 3.53 0 1 0-5.543-4.372 3.53 3.53 0 0 0 5.544 4.372z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "61j4wczjoa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h85.24v49.2H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.c5f507e68286dd26e520d022e2ea180f.svg";
export { ForwardRef as ReactComponent };